import { apiService } from './api';

// Entreprise de l'utilisateur courant + usage (plan, limites effectives, nb_stocks/nb_users).
// SUPER_ADMIN : renvoie { company: null, usage: null } — pas d'entreprise, pas une erreur.
export const getMyCompany = async () => {
  const response = await apiService.get('/admin/company');
  return response.data;
};

/**
 * Met à jour la fiche d'entreprise (écran « Ma société », ADMIN).
 *
 * 🔴 LE PAYLOAD SE CONSTRUIT CHAMP PAR CHAMP, JAMAIS `{...company}`.
 * La route n'accepte que **8 clés** et refuse toutes les autres en **400**,
 * nommément `plan`, `status`, `max_stocks`, `users_per_stock` et `logo_path`.
 * Or `Company.to_dict()` en renvoie **18**. Réétaler l'objet reçu ferait donc
 * échouer CHAQUE enregistrement, avec un message parlant de l'abonnement là où
 * l'utilisateur vient seulement de corriger son adresse.
 * C'est aussi la raison pour laquelle ce service n'expose PAS de helper
 * « envoyer tout l'objet » : la tentation doit rester impossible.
 *
 * Contrat : clé ABSENTE = inchangée · `null` ou `''` = effacement explicite.
 * ⚠️ SAUF `name`, colonne NOT NULL : l'effacer rend 400.
 *
 * Réponse : `{ company }` — SANS `usage`, contrairement au GET. Aucun des 8
 * champs ne touche aux compteurs ; l'appelant conserve son `usage`.
 */
export const updateMyCompany = async (payload) => {
  const response = await apiService.put('/admin/company', payload);
  return response.data;
};

/**
 * Téléverse le logo. `file` est un File du navigateur ; le champ DOIT s'appeler
 * `logo` (le serveur rend 400 sur tout autre nom).
 *
 * ⚠️ Plafond serveur de 2 Mo, refusé en 400 avec `taille_max_octets` et
 * `taille_recue_octets` dans le corps. L'appelant vérifie la taille avant
 * l'envoi pour éviter un aller-retour inutile — mais le SERVEUR reste
 * l'autorité, la vérification front n'est qu'une économie de bande passante.
 */
export const uploadCompanyLogo = async (file) => {
  const formData = new FormData();
  formData.append('logo', file);
  const response = await apiService.upload('/admin/company/logo', formData);
  return response.data;
};

/**
 * Retire le logo. Vide la COLONNE, pas le fichier sur le disque (cf. la
 * docstring de la route : un orphelin est inoffensif, une suppression
 * concurrente ne l'est pas).
 * Retirer un logo déjà absent rend 200, pas 404 — l'appelant demande un ÉTAT.
 */
export const deleteCompanyLogo = async () => {
  const response = await apiService.delete('/admin/company/logo');
  return response.data;
};
